import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=dcb2b3c0&scoped=true"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=dcb2b3c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2b3c0",
  null
  
)

export default component.exports